import Ong from '../domain/models/ong.model';

class ongDataAssembler {

  static assemble(dataArray) {
    const ongList = dataArray.ongList;
    const contributions = dataArray.contributions;

    return ongList.map((ongData) => {
      let ong = new Ong(ongData);

      const ongStaticData = ong.getStaticData();
      ong.imgLogo = ongStaticData.imgLogo;

      ong.setDetails(ongStaticData);
      ong.setContribution(contributions);
      return ong;
    });
  }
}

export default ongDataAssembler;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/ong.assembler.js